import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=template&id=500abfe4&scoped=true"
import script from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500abfe4",
  null
  
)

export default component.exports